import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// Any element with a 'title' parameter
type titleElement = { title: string };

@Pipe({ name: 'representList' })
export class RepresentList implements PipeTransform {
  private readonly SEPARATION_SYMBOL: string = ', ';
  private translateService = inject(TranslateService);

  public transform(list: string[] | titleElement[], translatePrefix?: string, defalutVaue?: string): string {
    const _list: string[] = [];

    if (list)
      list.forEach((item: string | titleElement) => {
        if (typeof item === 'string') {
          _list.push(item);
        } else {
          _list.push(item.title);
        }
      });

    const prefix = translatePrefix ? translatePrefix : '';
    if (!_list?.length) {
      return defalutVaue ? (this.translateService.instant(defalutVaue) as string) : '';
    }

    return _list
      .map((item: string) => this.translateService.instant(prefix + item) as string)
      .map((item: string, index: number, arr: string[]) =>
        arr.length - 1 === index ? item : `${item}${this.SEPARATION_SYMBOL} `,
      )
      .join('');
  }
}
